import { Navigate, Outlet } from 'react-router-dom';
import { HOME_ROUTE } from '@config/routes';
import { useAuthStore } from '@stores/auth.store';
import { LoadingState } from '@shared/components';

/** Require an admin role; non-admins fall back to the user app. */
export function AdminGuard(): React.JSX.Element {
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);

  if (!isInitialized) return <LoadingState fullscreen />;
  if (!isAuthenticated) return <Navigate to="/admin" replace />;
  if (user?.role !== 'admin') return <Navigate to={HOME_ROUTE} replace />;
  return <Outlet />;
}
